var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStrategicInitiative(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/sidebar-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sidebar-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M0 5.81V14.19C0 17.83 2.17 20 5.81 20H14.19C14.39 20 14.59 19.99 14.78 19.98C16.01 19.9 17.05 19.55 17.87 18.95C18.29 18.66 18.66 18.29 18.95 17.87C19.64 16.92 20 15.68 20 14.19V5.81C20 2.37 18.06 0.24 14.78 0.03C14.59 0.00999997 14.39 0 14.19 0H5.81C4.32 0 3.08 0.36 2.13 1.05C1.71 1.34 1.34 1.71 1.05 2.13C0.36 3.08 0 4.32 0 5.81Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.28 0V20H14.19C14.39 20 14.59 19.99 14.78 19.98V0.03C14.59 0.00999997 14.39 0 14.19 0H13.28Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.02997 13.3099C7.21997 13.3099 7.40997 13.2399 7.55997 13.0899L10.12 10.5299C10.41 10.2399 10.41 9.75988 10.12 9.46988L7.55997 6.90988C7.26997 6.61988 6.78997 6.61988 6.49997 6.90988C6.20997 7.19988 6.20997 7.67988 6.49997 7.96988L8.51997 9.99988L6.49997 12.0299C6.20997 12.3199 6.20997 12.7999 6.49997 13.0899C6.63997 13.2399 6.82997 13.3099 7.02997 13.3099Z",
    fill: "#039855"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategicInitiative);
export default __webpack_public_path__ + "static/media/strategicInitiative.4768016be3269dfd949e2f37521c2f98.svg";
export { ForwardRef as ReactComponent };